
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model } from '../controlador';
    import resumen from './resumen/resumen.vue';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            resumen,
        }
    } )
    export default class Componente extends Vue
    {
        public get Controlador() { return Vue.observable( Model ); }
        public get Estado() { return this.Controlador.Vista.Estado; }
        public get Modo() { return this.Controlador.Vista.Modo; }
        public get Vista() { return this.Controlador.Vista; }

        async mounted()
        {
            await this.Controlador.Iniciar();
            this.Refrescar();
        }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        public Refresh: boolean = false;
        public Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }

    }
